// Only these drafts can make progress through automatic synchronization.
// Conflicts and retained recovery copies need a person's review instead.
export const draftNeedsReview = draft => draft.status !== 'synced'
  && (draft.recoveryOnly || !['saved-on-device', 'syncing'].includes(draft.status));

export function countDeviceDrafts(drafts) {
  return {
    reviewCount: drafts.filter(draftNeedsReview).length,
    pendingCount: drafts.filter(draft => draft.status !== 'synced' && !draftNeedsReview(draft)).length,
    syncingCount: drafts.filter(draft => draft.status === 'syncing' && !draftNeedsReview(draft)).length,
  };
}

export const OPEN_DEVICE_DRAFTS = 'vela:open-device-drafts';

export const isRetainedVisitPreview = visit => Boolean(visit?.offlineDraftId
  && draftNeedsReview({ status: visit.offlineStatus }));

export const RETAINED_VISIT_PREVIEW_MESSAGE = 'This retained device draft is read-only. Review the current server chart before explicitly recovering this draft from Review device drafts.';
